import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import {APP_CONFIG} from './config/app.config';

const reactPlugin = new ReactPlugin();

const connectionString = "InstrumentationKey=d1200d47-30ad-47e4-a695-5ef213d44ad4;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=7e4ec9c2-a839-45b3-83a7-219ce88eb971";

const noopAppInsights = {
    trackEvent: () => {},
    trackException: () => {},
    setAuthenticatedUserContext: () => {},
    clearAuthenticatedUserContext: () => {},
};

let appInsights = noopAppInsights;

if (APP_CONFIG.features?.enableAnalytics && connectionString) {
    appInsights = new ApplicationInsights({
        config: {
            connectionString,
            enableAutoRouteTracking: true,
            extensions: [reactPlugin],
        }
    });

    appInsights.loadAppInsights();
}

export {appInsights, reactPlugin};